<template>
	<rs-survey-response
		:surveyId="surveyId"
		:targetKey="k"
	></rs-survey-response>
		<!--  :surveyType="t" -->
</template>

<script>
import RsSurveyResponse from "@/redsurvey/components/survey/RsSurveyResponse";
export default {
  components: {
    RsSurveyResponse,
  },
  computed: {
    surveyId() {
      return Number(this.$route.params.surveyId);
    },
    k() {
      return this.$route.query.k;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>